import React from 'react';

interface StatusOverlayProps {
  message: string;
  visible: boolean;
}

export const StatusOverlay = React.memo(function StatusOverlay({ message, visible }: StatusOverlayProps) {
  if (!message) return null;

  return (
    <div
      className={`kollab-player-status-overlay ${visible ? 'kollab-player-status-overlay--visible' : ''}`}
      aria-live="polite"
      aria-atomic="true"
    >
      {message}
    </div>
  );
});
